var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, takeLatest } from 'redux-saga/effects';
import download from 'downloadjs';
import { E_USERS_ACTION_TYPES } from 'src/redux/users/actionTypes';
import { usersServices } from 'src/services/users/usersServices';
import { getI18n, getRealm } from 'src/redux/core/coreSelectors';
import { usersActions } from 'src/redux/users/usersActions';
import { buildQueryParams } from 'src/shared/helpers/urlHelpers';
import { getFilters } from 'src/redux/users/usersSelectors';
import { coreActions } from 'src/redux/core/coreActions';
import { E_SNACKBAR_TYPE } from 'src/ui/components/SnackBar/SnackBar';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { ERROR_CODE } from 'src/services/constants';
import { E_ERROR_CODE_USER_CREATION } from 'src/services/users/types/usersAPITypes';
import { getGroups } from 'src/redux/auth/authSelectors';
function fetchUsers() {
    var realm, filters, body, callAPI, _a, payload, status, error, errorMessage, userList, usersParsed;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, select(getFilters)];
            case 2:
                filters = _b.sent();
                return [4 /*yield*/, put(usersActions.updateUsersCollectionLoading(true))];
            case 3:
                _b.sent();
                body = __assign({ size: filters.count, page: filters.offset / filters.count }, (filters.search ? { search: "*".concat(filters.search, "*") } : null));
                return [4 /*yield*/, usersServices.fetchUsers(realm, buildQueryParams(body))];
            case 4:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 5:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 6];
                return [3 /*break*/, 8];
            case 6:
                userList = payload._embedded ? payload._embedded.userList : [];
                usersParsed = { collectionResults: userList, total: payload.page.totalElements };
                return [4 /*yield*/, put(usersActions.fetchUsersSucceeded(usersParsed))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [4 /*yield*/, put(usersActions.updateUsersCollectionLoading(false))];
            case 9:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function updateFilters(action) {
    var filters, updatedFiltersState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filters = action.filters;
                return [4 /*yield*/, select(getFilters)];
            case 1:
                updatedFiltersState = _a.sent();
                return [4 /*yield*/, put(usersActions.updateUsersFilterSucceeded(__assign(__assign(__assign({}, updatedFiltersState), filters), { count: filters.count || updatedFiltersState.resultsPerPage, resultsPerPage: filters.count || updatedFiltersState.resultsPerPage })))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function exportUsersInCSV() {
    var realm, callAPI, _a, payload, status, error, errorMessage, headers, contentDispositionHeader, contentTypeHeader, fileName, mimeType;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, call(function () { return usersServices.exportUsersInCSV(realm); })];
            case 2:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 3:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage, headers = _a.headers;
                if (error) {
                }
                else {
                    contentDispositionHeader = headers['content-disposition'];
                    contentTypeHeader = headers['content-type'];
                    if (contentDispositionHeader && contentTypeHeader) {
                        fileName = contentDispositionHeader.split('=')[1].slice(1, -1);
                        mimeType = contentTypeHeader.split(';')[0];
                        download("data:".concat(mimeType, ";charset=utf-8,").concat(encodeURI(payload)), fileName, mimeType);
                    }
                }
                return [2 /*return*/];
        }
    });
}
function importUsersInCSV(action) {
    var file, realm, callAPI, _a, payload, status, error, errorMessage, _b, nbOfUsers, nbOfCreatedUsers, nbOfUpdatedUsers, results, globalMessages, parsedResponse;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                file = action.file;
                return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _c.sent();
                return [4 /*yield*/, put(usersActions.updateUsersImportLoading(true))];
            case 2:
                _c.sent();
                return [4 /*yield*/, call(function () { return usersServices.importUsers(realm, { file: file }); })];
            case 3:
                callAPI = (_c.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 4:
                _a = _c.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 6];
                return [4 /*yield*/, put(usersActions.importUsersInCSVSucceeded({ result: { isError: true } }))];
            case 5:
                _c.sent();
                return [3 /*break*/, 9];
            case 6:
                _b = payload, nbOfUsers = _b.nbOfUsers, nbOfCreatedUsers = _b.nbOfCreatedUsers, nbOfUpdatedUsers = _b.nbOfUpdatedUsers, results = _b.results, globalMessages = _b.globalMessages;
                parsedResponse = {
                    isError: false,
                    nbOfUsers: nbOfUsers,
                    nbOfCreatedUsers: nbOfCreatedUsers,
                    nbOfUpdatedUsers: nbOfUpdatedUsers,
                    globalMessages: globalMessages,
                    info: results.map(function (result) { return ({
                        data: result.csvRecordData,
                        messages: result.messages,
                        userCreated: result.userCreated,
                        userUpdated: result.userUpdated,
                    }); }),
                };
                return [4 /*yield*/, put(usersActions.importUsersInCSVSucceeded(parsedResponse))];
            case 7:
                _c.sent();
                return [4 /*yield*/, put(usersActions.fetchUsersRequested())];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [4 /*yield*/, put(usersActions.updateUsersImportLoading(false))];
            case 10:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function fetchUserDetails(action) {
    var userId, realm, callAPI, _a, payload, status, error, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                userId = action.userId;
                return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, call(function () { return usersServices.fetchUserDetails(realm, userId); })];
            case 2:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 3:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 4];
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(usersActions.fetchCurrentUserDetailsSucceeded(payload))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function updateUser(action) {
    var user, groupsCollection, realm, i18n, userParsed, callAPI, _a, payload, status, error, errorMessage, _b, errorUsernameConflictDescription, errorEmailConflictDescription, errorDescription, successDescription;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                user = action.user;
                return [4 /*yield*/, select(getGroups)];
            case 1:
                groupsCollection = _c.sent();
                return [4 /*yield*/, select(getRealm)];
            case 2:
                realm = _c.sent();
                return [4 /*yield*/, select(getI18n)];
            case 3:
                i18n = _c.sent();
                userParsed = __assign(__assign({}, user), { groups: user.groups
                        .filter(function (group) { return groupsCollection.findIndex(function (groupColl) { return groupColl.name === group.name; }) !== -1; })
                        .map(function (group) { return ({
                        path: "/".concat(group.name),
                    }); }) });
                return [4 /*yield*/, call(function () { return usersServices.updateUser(realm, userParsed); })];
            case 4:
                callAPI = (_c.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 5:
                _a = _c.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 14];
                if (!(status === ERROR_CODE.CONFLICT)) return [3 /*break*/, 11];
                _b = payload.code;
                switch (_b) {
                    case E_ERROR_CODE_USER_CREATION.USERNAME_CONFLICT: return [3 /*break*/, 6];
                    case E_ERROR_CODE_USER_CREATION.EMAIL_CONFLICT: return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 6:
                errorUsernameConflictDescription = getPropsByKeyPath(i18n, 'components.addOrEditUserModal.errorUsernameConflict');
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.ERROR,
                        description: errorUsernameConflictDescription,
                    }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 10];
            case 8:
                errorEmailConflictDescription = getPropsByKeyPath(i18n, 'components.addOrEditUserModal.errorEmailConflict');
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.ERROR,
                        description: errorEmailConflictDescription,
                    }))];
            case 9:
                _c.sent();
                return [3 /*break*/, 10];
            case 10: return [3 /*break*/, 13];
            case 11:
                errorDescription = getPropsByKeyPath(i18n, 'components.addOrEditUserModal.errorUnknown');
                return [4 /*yield*/, put(coreActions.addNotificationRequested({ type: E_SNACKBAR_TYPE.ERROR, description: errorDescription }))];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13: return [3 /*break*/, 17];
            case 14:
                console.log(user.keycloakId);
                successDescription = getPropsByKeyPath(i18n, "components.addOrEditUserModal.".concat(user.keycloakId ? 'successfulUpdateUser' : 'successfulCreationUser')).replace('$username', user.username);
                return [4 /*yield*/, put(coreActions.addNotificationRequested({ type: E_SNACKBAR_TYPE.VALID, description: successDescription }))];
            case 15:
                _c.sent();
                return [4 /*yield*/, put(usersActions.fetchUsersRequested())];
            case 16:
                _c.sent();
                _c.label = 17;
            case 17: return [2 /*return*/];
        }
    });
}
function deleteUser(action) {
    var user, username, keycloakId, realm, i18n, callAPI, _a, payload, status, error, errorMessage, errorDeleteDescription, successDeleteDescription;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                user = action.user;
                username = user.username, keycloakId = user.keycloakId;
                return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, select(getI18n)];
            case 2:
                i18n = _b.sent();
                return [4 /*yield*/, call(function () { return usersServices.deleteUser(realm, keycloakId); })];
            case 3:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 4:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 6];
                errorDeleteDescription = getPropsByKeyPath(i18n, 'components.deleteUserModal.errorDeleteUser');
                return [4 /*yield*/, put(coreActions.addNotificationRequested({ type: E_SNACKBAR_TYPE.ERROR, description: errorDeleteDescription }))];
            case 5:
                _b.sent();
                return [3 /*break*/, 9];
            case 6:
                successDeleteDescription = getPropsByKeyPath(i18n, 'components.deleteUserModal.successfulDeleteUser').replace('$username', username);
                return [4 /*yield*/, put(coreActions.addNotificationRequested({ type: E_SNACKBAR_TYPE.INFO, description: successDeleteDescription }))];
            case 7:
                _b.sent();
                return [4 /*yield*/, put(usersActions.fetchUsersRequested())];
            case 8:
                _b.sent();
                _b.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
export function usersSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.FETCH_USERS_REQUESTED, fetchUsers)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.UPDATE_USERS_FILTERS_REQUESTED, updateFilters)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.EXPORT_USERS_IN_CSV_REQUESTED, exportUsersInCSV)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.IMPORT_USERS_IN_CSV_REQUESTED, importUsersInCSV)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.FETCH_CURRENT_USER_DETAILS_REQUESTED, fetchUserDetails)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.UPDATE_USER_REQUESTED, updateUser)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_USERS_ACTION_TYPES.DELETE_USER_REQUESTED, deleteUser)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
